/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

const PromisePool = require('es6-promise-pool')

angular.module('FlexyBeautyApp.services').
    factory('Customer_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceBooking = $resource( baseUrl +'rest/customers/:id',{}, {
            query: { method: 'GET', isArray: true },
            queryByCursor: { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/queryByCursor/:cursorNumber'},
            queryByCursorDeleted: { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/queryByCursorDeleted/:cursorNumber'},
            nbCustomers: { method: 'GET', isArray: false , url:baseUrl+'rest/customers/nbCustomers'},
            listFromOffset: { method: 'POST', isArray: false , url:baseUrl+'rest/customers/listFromOffset'},
            get:   { method: 'GET'},
            getById:   { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/byId/:id'},
            getByEmail:   { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/byEmail/:email'},
            getByPhone:   { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/byPhone/:phone'},
            getBookings:   { method: 'GET' , isArray: true , url:baseUrl+'rest/customers/:id/bookings'},
            getSales:   { method: 'GET' , isArray: true , url:baseUrl+'rest/customers/:id/sales'},
            getGiftItems:   { method: 'GET' , isArray: true , url:baseUrl+'rest/customers/:id/giftItems'},
            getCardRegistration : { method: 'GET' , isArray: false , url:baseUrl+'rest/customers/:id/getCardRegistration'},
            login: { method: 'POST', url:baseUrl+'rest/customers/login'},
            logout: { method: 'POST', url:baseUrl+'rest/customers/logout'},
            register: { method: 'POST', url:baseUrl+'rest/customers/register'},
            saveAccount: { method: 'POST', url:baseUrl+'rest/customers/saveAccount'},
            saveOptInOut: { method: 'POST', url:baseUrl+'rest/customers/saveOptInOut'},
            fusion: { method: 'POST', url:baseUrl+'rest/customers/fusion'},
            forgotPwd: { method: 'POST', url:baseUrl+'rest/customers/forgotPwd'},
            changePwd: { method: 'POST', url:baseUrl+'rest/customers/changePwd'},
            sendSmsActivationCode : {method: 'POST', url:baseUrl+'rest/customers/sendSmsActivationCode'},
            emptyGarbage : {method: 'POST', url:baseUrl+'rest/customers/emptyGarbage'},
        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Customer',["Customer_Resource","CustomerData", "OptInOut","PhoneFormat", function (Customer_Resource,CustomerData,OptInOut,PhoneFormat)
    {
        var  Customer = function (resource, isApplicationLoading)
        {
            this.id = null;
            this.idReserveWithGoogle = null;
            this.isDeleted = false;
            this.lastName = null;
            this.firstName = null;
            this.gender = null;
            this.email = null;
            this.comment = null;
            this.isVerified = false;
            this.phone = null;
            this.password = null;
            this.address1 = null;
            this.address2 = null;
            this.city = null;
            this.postCode = null;
            this.origin = null;
            this.online = null;
            this.isBirthDate = false;
            this.birthDate = null;
            this.bookings = []; // generate a local link to booking
            this.sales = []; // generate a local link to sales
            this.giftItems = []; // generate a local link to giftItem (beneficiaries)
            this.hasWebPwd = false;
            this.hasMobileApp = false;
            this.version = null;
            this.optInOut = null;
            this.isCGVAccepted = null;
            this.customerLabelSearch = null;
            this.customerInterNationalMobileNumber = null;
            this.customerNationalMobileNumber = null;
            this.customerInterNationalLandlineNumber = null;
            this.customerNationalLandlineNumber = null;
            this.loadObject(resource);
            CustomerData.add(this, isApplicationLoading);
        };

        Customer.prototype.loadCustomerLabelSearch = function (customer) {
            this.customerLabelSearch = customer.lastName + " " + customer.firstName + " | ";
            if (customer.phone) {
                let phone = customer.phoneDisplay = PhoneFormat.formatNumberWithoutCountry(customer.phone);
                this.customerLabelSearch += phone;
            } else if (customer.landline) {
                this.customerLabelSearch += PhoneFormat.formatNumberWithoutCountry(customer.landline);
            }
        };

        Customer.prototype.createInterNationalAndNationalPhoneFormat = function(){
            this.customerNationalMobileNumber = PhoneFormat.returnNationalFormat(this.phone).replace(/\s/g, '');
            this.customerInterNationalMobileNumber = PhoneFormat.returnInternationalFormat(this.phone).replace(/\s/g, '');
            this.customerInterNationalLandlineNumber = PhoneFormat.returnInternationalFormat(this.landline).replace(/\s/g, '');
            this.customerNationalLandlineNumber = PhoneFormat.returnNationalFormat(this.landline).replace(/\s/g, '')
        };

        Customer.prototype.loadObject = function(object)
        {
            if (object!==undefined && object!=null)
            {
                if (!this.id)
                    this.id = object.id;
                this.idReserveWithGoogle = object.idReserveWithGoogle;
                this.isDeleted = object.isDeleted;
                this.lastName = object.lastName;
                this.firstName = object.firstName;
                this.gender = object.gender;
                this.email = object.email;
                this.comment = object.comment;
                this.isVerified = object.isVerified;
                this.phone = object.phone;
                this.landline = object.landline;
                this.createInterNationalAndNationalPhoneFormat();
                this.loadCustomerLabelSearch(object);
                this.address1 = object.address1;
                this.address2 = object.address2;
                this.city = object.city;
                this.postCode = object.postCode;
                this.origin = object.origin;
                this.online = object.online;
                this.hasWebPwd = object.hasWebPwd;
                this.hasMobileApp = object.hasMobileApp;
                this.isCGVAccepted = object.isCGVAccepted;
                this.isBirthDate = object.isBirthDate;
                if (object.birthDate)
                    this.birthDate = new Date(object.birthDate);
                if (object.version)
                    this.version = object.version;
                if(object.optInOut)
                    this.optInOut = new OptInOut(object.optInOut, this.id);
            }
        };
        Customer.prototype.getObjectResource = function()
        {
            let rsCustomer = new Customer_Resource();
            rsCustomer.id = this.id;
            rsCustomer.idReserveWithGoogle = this.idReserveWithGoogle;
            rsCustomer.isDeleted = this.isDeleted;
            rsCustomer.firstName = this.firstName;
            rsCustomer.lastName = this.lastName;
            rsCustomer.gender = this.gender;
            rsCustomer.email = this.email;
            rsCustomer.comment = this.comment;
            rsCustomer.isVerified = this.isVerified;
            rsCustomer.phone = this.phone;
            rsCustomer.landline = this.landline;
            rsCustomer.address1 = this.address1;
            rsCustomer.address2 = this.address2;
            rsCustomer.city = this.city;
            rsCustomer.postCode = this.postCode;
            rsCustomer.origin = this.origin;
            rsCustomer.online = this.online;
            rsCustomer.isBirthDate = this.isBirthDate;
            rsCustomer.birthDate = this.birthDate;

            return rsCustomer;
        };
        Customer.prototype.getRegisterRequest = function()
        {
            let rsCustomer = new Customer_Resource();
            rsCustomer.id = this.id;
            rsCustomer.idReserveWithGoogle = this.idReserveWithGoogle;
            rsCustomer.firstName = this.firstName;
            rsCustomer.lastName = this.lastName;
            rsCustomer.email = this.email;
            rsCustomer.isVerified = this.isVerified;
            rsCustomer.phone = this.phone;
            rsCustomer.landline = this.landline;
            rsCustomer.address1 = this.address1;
            rsCustomer.address2 = this.address2;
            rsCustomer.city = this.city;
            rsCustomer.postCode = this.postCode;
            rsCustomer.password = this.password;
            rsCustomer.currentPassword = this.currentPassword;
            rsCustomer.isBirthDate = this.isBirthDate;
            rsCustomer.birthDate = this.birthDate;
            rsCustomer.gender = this.gender;
            rsCustomer.isCGVAccepted = this.isCGVAccepted;
            rsCustomer.optInOut = this.optInOut;
            return rsCustomer;
        };
        Customer.prototype.getLoginRequest = function()
        {
            let rsCustomer = new Customer_Resource();
            rsCustomer.email =this.email;
            rsCustomer.phone =this.phone;
            rsCustomer.password = this.password;
            return rsCustomer;
        };
        Customer.prototype.getId = function()
        {
            return this.id;
        };
        Customer.prototype.getLabel = function()
        {
            return this.firstName + ' ' + this.lastName;
        };
        Customer.prototype.getPhone = function()
        {
            return this.phone;
        };

        Customer.prototype.getEmail = function() {
            return this.email;
        };

        Customer.prototype.setId = function(id) {
            this.id = id;
        };

        Customer.prototype.addBooking = function(booking) {
            let index = this.bookings.indexOf(booking);
            //Not already there
            if (index === -1) {
                this.bookings.push(booking);
            }
        };

        Customer.prototype.removeBooking = function(booking) {
            let index = this.bookings.indexOf(booking);
            //Found
            if (index !== -1) {
                this.bookings.splice(index, 1);
            }
        };

        Customer.prototype.addSale = function(sale) {
            let index = this.sales.indexOf(sale);
            //Not already there
            if (index === -1) {
                this.sales.push(sale);
            }
        };

        /**
         * Check if the customer has bought an item (product, service, cure, ...).
         *
         * @param itemView the itemView
         *
         * return boolean
         */
        Customer.prototype.hasBoughtItem = function(itemView) {
            if (itemView && itemView.categoryType && itemView.getModel()) {
                return this.sales.some( (sale) => sale.hasItemByIdAndType(itemView.getModel().id, itemView.categoryType) == true);
            }
            return false;
        };

        Customer.prototype.removeSale = function(sale) {
            let index = this.sales.indexOf(sale);
            //Found
            if (index !== -1) {
                this.sales.splice(index, 1);
            }
        };

        Customer.prototype.addGiftItem = function(giftItem) {
            let index = this.giftItems.indexOf(giftItem);
            //Not already there
            if (index === -1) {
                this.giftItems.push(giftItem);
            }
        };

        Customer.prototype.removeGiftItem = function(giftItem)
        {
            let index = this.giftItems.indexOf(giftItem);
            if (index !== -1)//Found
            {
                this.giftItems.splice(index,1);
            }

        };

        Customer.prototype.hasSaleBefore = function(day, currentBooking)
        {
            return (this.getLoyaltySalesOfPeriod(null, day, null, currentBooking).length > 0);
        };

        Customer.prototype.hasSaleBetween = function(firstDay, endDay, currentBooking, saleObjects, additionalFilters, currentDay)
        {
            return (this.getLoyaltySalesOfPeriod(firstDay, endDay, null, currentBooking, saleObjects, additionalFilters, currentDay).length > 0);
        };

        Customer.prototype.getLoyaltySalesOfPeriod = function(beginDay, endDay, hrId, currentBooking, saleObjects, additionalFilters, currentDay)
        {
            let salesOfperiod = [];
            for(let i = 0; i < this.sales.length; i++){
                if (this.sales[i].day &&
                    ( (beginDay && (this.sales[i].day.id >= beginDay.id)) || !beginDay) &&
                    ( (endDay && (this.sales[i].day.id < endDay.id)) || !endDay) &&
                    (!hrId || (hrId && this.sales[i].hrIsWorking(hrId))) &&
                    (!currentBooking || (currentBooking && (!currentBooking.sale || currentBooking.sale !== this.sales[i]))) &&
                    !this.sales[i].isCancelledOrCredit()
                ) {
                    if(!saleObjects && !additionalFilters) {
                        salesOfperiod.push(this.sales[i]);
                    }
                    else{
                        for (let j = 0; j < this.sales[i].saleServices.length; j++) {
                            if(this.sales[i].saleServices[j].subSaleServices.length === 0){
                               if(this.sales[i].saleServices[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)){
                                    if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                        salesOfperiod.push(this.sales[i]);
                                    }
                               }
                            }
                            else{
                                for (let k = 0; k < this.sales[i].saleServices[j].subSaleServices.length; k++) {
                                    if (this.sales[i].saleServices[j].subSaleServices[k].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)) {
                                        if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                            salesOfperiod.push(this.sales[i]);
                                        }
                                    }
                                }
                            }
                        }
                        for (let j = 0; j < this.sales[i].saleProducts.length; j++) {
                            if(this.sales[i].saleProducts[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)){
                                if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                    salesOfperiod.push(this.sales[i]);
                                }
                            }
                        }

                        for (let j = 0; j < this.sales[i].saleCures.length; j++) {
                            if(this.sales[i].saleCures[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)){
                                if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                    salesOfperiod.push(this.sales[i]);
                                }
                            }
                        }

                        for (let j = 0; j < this.sales[i].loyaltyCardItems.length; j++) {
                            if(this.sales[i].loyaltyCardItems[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)){
                                if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                    salesOfperiod.push(this.sales[i]);
                                }
                            }
                        }

                        for (let j = 0; j < this.sales[i].giftItems.length; j++) {
                            if(this.sales[i].giftItems[j].matchAllSaleObjects(saleObjects, additionalFilters, beginDay, currentDay)){
                                if(salesOfperiod.indexOf(this.sales[i]) === -1){
                                    salesOfperiod.push(this.sales[i]);
                                }
                            }
                        }

                    }
                }
            }
            return salesOfperiod;
        };

        Customer.prototype.hasBookingBefore = function(day, currentSale)
        {
            return (this.getLoyaltyBookingsOfPeriod(null, day, null, currentSale).length > 0);
        };

        Customer.prototype.hasBookingBetween = function(firstDay, endDay, currentSale, bookingObjects, additionalFilters)
        {
            return (this.getLoyaltyBookingsOfPeriod(firstDay, endDay, null, currentSale, bookingObjects, additionalFilters).length > 0);
        };

        Customer.prototype.getLoyaltyBookingsOfPeriod = function(beginDay, endDay, hrId, currentSale, bookingObjects, additionalFilters)
        {
            var bookingsOfperiod = [];
            for(let i = 0; i < this.bookings.length; i++){
                if (this.bookings[i].day &&
                    ( (beginDay && (this.bookings[i].day.id >= beginDay.id)) || !beginDay) &&
                    ( (endDay && (this.bookings[i].day.id < endDay.id)) || !endDay) &&
                    (!hrId || (hrId && this.bookings[i].hrIsWorking(hrId))) &&
                    (!currentSale || (currentSale && (!currentSale.booking || currentSale.booking != this.bookings[i]))) &&
                    this.bookings[i].status !== "notCame") {

                    if(!bookingObjects && !additionalFilters) {
                        bookingsOfperiod.push(this.bookings[i]);
                    }
                    else {
                        for (let j = 0; j < this.bookings[i].bookingServices.length; j++) {
                            if(this.bookings[i].bookingServices[j].isPackage && this.bookings[i].bookingServices[j].subBookingServices.length>0){
                                for (let k = 0; k < this.bookings[i].bookingServices[j].subBookingServices.length; k++) {
                                    if (this.bookings[i].bookingServices[j].subBookingServices[k].matchAllBookingObjects(bookingObjects, additionalFilters, beginDay)) {
                                        if (bookingsOfperiod.indexOf(this.bookings[i]) === -1) {
                                            bookingsOfperiod.push(this.bookings[i]);
                                        }
                                    }
                                }
                            }
                            else{
                                if (this.bookings[i].bookingServices[j].matchAllBookingObjects(bookingObjects, additionalFilters, beginDay)) {
                                    if (bookingsOfperiod.indexOf(this.bookings[i]) === -1) {
                                        bookingsOfperiod.push(this.bookings[i]);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return bookingsOfperiod;
        };

        return Customer;
    }
    ]);

angular.module('FlexyBeautyApp.services')
    .factory('CustomerSrv', ["$log", "Customer_Resource", "UserActionData", "Customer", "CustomerData", "Booking", "DayData", "Day", "ServerSrv", "Sale",
            "GiftItem", "BookingSrv", "SaleSrv", "BookingData", "SaleData", "CureItemToServiceSrv", "GiftItemData", "gettextCatalog", "Decorators", "TimeMeasures", "Constants", "$http",
        function ($log, Customer_Resource, UserActionData, Customer, CustomerData, Booking, DayData, Day, ServerSrv, Sale,
                  GiftItem, BookingSrv, SaleSrv, BookingData, SaleData, CureItemToServiceSrv, GiftItemData, gettextCatalog, Decorators, TimeMeasures, Constants, $http) {
            let customerSrv = {};

            //FIXME : not used, need to be delete
            customerSrv.query = function (successFunction, errorFunction) {
                Customer_Resource.query(
                        {}, //params
                        function (data) {   //success

                            for (let i = 0; i < data.length; i++) {
                                new Customer(data[i]);//Auto Add to CustomerData
                            }
                            if (successFunction !== undefined) {
                                successFunction(CustomerData.customers);
                            }

                        },
                        function (data) {   //failure
                            $log.error("Customer_Resource.query error");
                            $log.error(data);
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        });
            };

            customerSrv.getCustomerExport = function () {
                return $http({
                    method: "GET", url: 'rest/v2/customers/export?format=XLSX',
                    params: {'format': Constants.EXPORT_FORMAT.XLSX, 'timezone': 'Europe/Paris'},
                    responseType: 'blob'
                });
            };
            //FIXME : not used, need to be delete
            customerSrv.queryByCursor = function(cursorNumber,successFunction,errorFunction)
            {
                Customer_Resource.queryByCursor(
                    {cursorNumber: cursorNumber}, //params
                    function (customerCursorInterface) {
                        if (customerCursorInterface.customers)
                            for (var i=0;i< customerCursorInterface.customers.length;i++)
                                new Customer(customerCursorInterface.customers[i]);//Auto Add to CustomerData

                        if (customerCursorInterface.nextCursorNumber)
                            customerSrv.queryByCursor(customerCursorInterface.nextCursorNumber,successFunction,errorFunction);
                        else//finish
                            if (successFunction!== undefined)
                                successFunction(CustomerData.customers);


                    },
                    function (data) {   //failure
                        $log.error("Customer_Resource.query error");
                        $log.error(data);
                        if (errorFunction!== undefined)
                            errorFunction(data);
                    });
            };

            customerSrv.loadDeletedCustomersMaster = Decorators.timeMeasureDecorator(
                    (cursorNumber, isApplicationLoading) => {
                        return customerSrv.loadDeletedCustomers(cursorNumber, isApplicationLoading);
                    },
                    TimeMeasures.DELETED_CUSTOMERS_LOADING
            );

            customerSrv.loadDeletedCustomers = function(cursorNumber, isApplicationLoading) {
               return Customer_Resource.queryByCursorDeleted({cursorNumber: cursorNumber}).$promise.then(
                   (deletedCustomersResponse) => {
                        if (deletedCustomersResponse.customers) {
                            for (let i = 0; i < deletedCustomersResponse.customers.length; i++) {
                                new Customer(deletedCustomersResponse.customers[i], isApplicationLoading);//Auto Add to CustomerData
                            }
                        }
                        if (deletedCustomersResponse.nextCursorNumber) {
                            return customerSrv.loadDeletedCustomers(deletedCustomersResponse.nextCursorNumber, isApplicationLoading);
                        }
                    },
                    (data) => {
                        $log.error("Customer_Resource.queryByCursorDeleted error");
                        $log.error(data);
                    }
                 );
            };

            customerSrv.loadCustomers = Decorators.timeMeasureDecorator(
                    async (isApplicationLoading) => {
                        return await customerSrv.getNbCustomers().then(
                            async (data) =>  {
                                return await customerSrv.loadFromIds(data, isApplicationLoading);
                            }
                        );
                    },
                    TimeMeasures.CUSTOMERS_LOADING
            );

            customerSrv.getNbCustomers = function()
            {
                return Customer_Resource.nbCustomers({}).$promise;
            };

            customerSrv.loadFromIds = async function(data, isApplicationLoading)
            {
                let nbCustomers = data.size;
                if (nbCustomers !== 0) {
                    let size = 1000;
                    let start = 0;
                    let end = size - 1;
                    let loaders = [];
                    while (start < nbCustomers) {
                        if (end > nbCustomers)
                            end = nbCustomers - 1;
                        loaders.push({loading: true, start: start, end: end});
                        start = end + 1;
                        end += size;
                    }

                    let index = -1;
                    let promiseProducer = function () {
                        index++;
                        if(index < loaders.length) {
                            return customerSrv.listFromOffset(loaders[index].start, loaders[index].end - loaders[index].start + 1).then(
                                (customerList) => {
                                    if (customerList && customerList.customers) {
                                        for (let j = 0; j < customerList.customers.length; j++) {
                                            new Customer(customerList.customers[j], isApplicationLoading);
                                        }
                                    }
                                });
                        } else {
                            return null;
                        }
                    }

                    let pool = new PromisePool(promiseProducer, 10)

                    let poolPromise = pool.start()

                    return poolPromise;
                }
                else return Promise.resolve();
            };

            customerSrv.listFromOffset = function(start,size)
            {
                return new Promise((resolve, reject) => {
                    var rs = new Customer_Resource();
                    rs.start = start;
                    rs.size = size;
                    rs.$listFromOffset(
                        {}, //params
                        function (data) {
                            resolve(data);
                        },
                        function (data) {
                            reject(data);
                        }
                    );
                })
            };

            customerSrv.save = function(customer,successFunction,errorFunction) {
                ServerSrv.startSavingProcess(customerSrv.saveSync, customer, successFunction, errorFunction);
            };

            customerSrv.saveSync = function(customer,successFunction,errorFunction)
            {
                var CustomerRes = customer.getObjectResource();
                CustomerRes.$save({}, //no params
                    function (data) {
                        try{
                            customer.setId(data.id);
                            if (!customer.version || (data.version && data.version > customer.version))
                                customer.version = data.version;
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
            customerSrv.fusion = function(customerSource,customerTarget,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(customerSrv.fusionSync, customerSource,customerTarget, successFunction, errorFunction);
            };
            customerSrv.fusionSync = function(customerSource,customerTarget,successFunction,errorFunction)
            {
                //$timeout (function () {
                if (customerSource && customerTarget)
                {
                    var rsCustomerFusion = new Customer_Resource();
                    rsCustomerFusion.customerSourceId =  customerSource.id;
                    rsCustomerFusion.customerTargetId =  customerTarget.id;
                    rsCustomerFusion.$fusion({}, //no params
                        function (data) {
                            try{
                                if (successFunction !=undefined)
                                    successFunction(data);
                            }
                            finally {
                                ServerSrv.endSavingProcess(true);
                            }
                        },
                        function (data) {   //failure
                            //error handling goes here
                            try {
                                if (errorFunction != undefined)
                                    errorFunction(data);
                            }
                            finally {
                                ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                            }
                        }
                    );
                }


                //},2000)
            };
            customerSrv.remove = function(customer,successFunction,errorFunction)
            {
                CustomerData.remove(customer);
                ServerSrv.startSavingProcess(customerSrv.removeSync, customer, successFunction, errorFunction);
            };
            customerSrv.removeSync =  function(customer,successFunction,errorFunction)
            {
                var customerSrv = new Customer_Resource();
                customerSrv.$remove({id:customer.getId()}, //params : id
                    function (data) {
                        try{
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            customerSrv.emptyGarbage = function(successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(customerSrv.emptyGarbageSync, successFunction, errorFunction);
            };
            customerSrv.emptyGarbageSync =  function(successFunction,errorFunction)
            {
                Customer_Resource.emptyGarbage({}, //params : id
                    function (data) {
                        try{
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

            };
            customerSrv.restore = function(customer,successFunction,errorFunction)
            {
                CustomerData.restore(customer);
                ServerSrv.startSavingProcess(customerSrv.restoreSync, customer, successFunction, errorFunction);
            };
            customerSrv.restoreSync = function(customer,successFunction,errorFunction)
            {
                //$timeout (function () {

                var CustomerRes = customer.getObjectResource();
                CustomerRes.$save({}, //no params
                    function (data) {
                        try{
                            customer.setId(data.id);
                            //TODO UserActionData.add(data.userAction);
                            if (successFunction !=undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );

                //},2000)
            };
            customerSrv.get =  function(id,successFunction,errorFunction)
            {
                Customer_Resource.get(
                    {id:id}, //params
                    function (customerResource) {
                        if (successFunction!=undefined)
                            successFunction(new Customer(customerResource));
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };
            customerSrv.getData =  function(customer,successFunction,errorFunction)
            {
                Customer_Resource.get(
                    {id:customer.id}, //params
                    function (customerResource) {
                        customer.loadObject(customerResource);
                        if (successFunction!=undefined)
                            successFunction(customer);
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };
            customerSrv.loadRelatedData = function(customer,endFunction) {
                customerSrv.loader = {bookingDataLoaded : false,
                    saleDataLoaded : false,
                    giftItemDataLoaded : false
                };
                BookingData.clear();
                SaleData.clear();
                if (customer) {
                    customer.bookings = [];// generate a local link to booking
                    customer.sales = [];// generate a local link to booking
                    customer.giftItems = [];// generate a local link to giftItem (beneficiaries)
                    customerSrv.getBookings(customer, function () {
                        customerSrv.loader.bookingDataLoaded = true;
                        customerSrv.finalizeLoadRelatedData(endFunction);
                    });
                    customerSrv.getSales(customer, function () {
                        customerSrv.loader.saleDataLoaded = true;
                        customerSrv.finalizeLoadRelatedData(endFunction);
                    });
                    customerSrv.getGiftItems(customer, function () {
                        customerSrv.loader.giftItemDataLoaded = true;
                        customerSrv.finalizeLoadRelatedData(endFunction);
                    });
                }
            } ;
            customerSrv.finalizeLoadRelatedData = function(endFunction)
            {
                if (customerSrv.loader.saleDataLoaded & customerSrv.loader.giftItemDataLoaded && customerSrv.loader.bookingDataLoaded)
                {
                    BookingSrv.loadRef();
                    SaleSrv.loadRef();
                    CureItemToServiceSrv.loadRef();
                    endFunction();
                }
            };
            customerSrv.getBookings =  function(customer,endFunction)
            {
                if (customer && customer.id)
                    Customer_Resource.getBookings(
                        {id:customer.id}, //params
                        function (bookingResources) {   //success

                            customer.bookings = [];
                            let bookings = [] ;
                            for (let i=0;i< bookingResources.length;i++)
                            {
                                let day = null;
                                if (bookingResources[i]!==undefined && bookingResources[i]!=null && bookingResources[i].dayId)
                                {
                                    day = DayData.getById(bookingResources[i].dayId);
                                    if (!day)
                                    {
                                        day = new Day();
                                        day.id =  bookingResources[i].dayId;
                                        DayData.add(day);
                                    }
                                }
                                let booking = new Booking(bookingResources[i],day,true);
                                booking.loadRef(false);
                                customer.addBooking(booking);
                                booking.customer = customer;
                                bookings.push(booking);
                            }
                            if (endFunction!=undefined)
                                endFunction(bookings);
                        },
                        function (data) {   //failure
                            console.info("Error when pulling bookings for " + customer.id);
                        });
            };
            customerSrv.getSales =  function(customer,endFunction)
            {
                if (customer && customer.id)
                    Customer_Resource.getSales(
                        {id:customer.id}, //params
                        function (saleResources) {   //success

                            customer.sales = [];
                            let sales = [] ;
                            for (let i=0;i< saleResources.length;i++)
                            {
                                let day = null;
                                if (saleResources[i]!==undefined && saleResources[i]!=null && saleResources[i].dayId)
                                {
                                    day = DayData.getById(saleResources[i].dayId);
                                    if (!day)
                                    {
                                        day = new Day();
                                        day.id =  saleResources[i].dayId;
                                        DayData.add(day);
                                    }
                                }
                                let sale = new Sale(saleResources[i],day,true);
                                customer.addSale(sale);
                                sales.push(sale);

                            }
                            for (let i=0;i< sales.length;i++)
                                sales[i].loadRef();
                            if (endFunction!=undefined)
                                endFunction(sales);
                        },
                        function (data) {   //failure
                            //error handling goes here
                            //TODO
                        });
            };
            customerSrv.getGiftItems =  function(customer,endFunction)
            {
                if (customer && customer.id)
                    Customer_Resource.getGiftItems(
                        {id:customer.id}, //params
                        function (giftItemResources) {   //success

                            let giftItems = [] ;
                            customer.giftItems = [];
                            let giftItem;
                            for (let i=0;i< giftItemResources.length;i++)
                            {
                                giftItem = GiftItemData.getById(giftItemResources[i].id);
                                if (!giftItem)
                                    giftItem = new GiftItem(giftItemResources[i]);
                                customer.addGiftItem(giftItem);
                                giftItems.push(giftItem);
                            }
                            if (endFunction!=undefined)
                                endFunction(giftItems);
                        },
                        function (data) {   //failure
                            //error handling goes here
                            //TODO
                        });
            };
            customerSrv.getCardRegistration =  function(customer,successFunction,errorFunction)
            {
                if (customer && customer.id)
                    Customer_Resource.getCardRegistration(
                        {id:customer.id}, //params
                        function (data) {
                            if (successFunction !=undefined)
                                successFunction(data);
                        },
                        function (errorObj) {
                            let message = "Undefined error";
                            if (errorObj && errorObj.data && errorObj.data.consumerMessage)
                                message = errorObj.data.consumerMessage;

                            if (errorFunction !=undefined)
                                errorFunction(message);
                        });

            };

            customerSrv.getById =  function(id,successFunction,errorFunction)
            {
                Customer_Resource.getById(
                    {id:id}, //params
                    function (customerResource) {
                        if (successFunction!=undefined)
                            successFunction(new Customer(customerResource));
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };

            customerSrv.getByEmail =  function(email,successFunction,errorFunction)
            {
                Customer_Resource.getByEmail(
                    {email:email},
                    function (customerResource) {
                        if (successFunction!=undefined)
                            successFunction(new Customer(customerResource));
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };
            customerSrv.getByPhone =  function(phone,successFunction,errorFunction)
            {
                Customer_Resource.getByPhone(
                    {phone:phone}, //params
                    function (customerResource) {
                        if (successFunction!=undefined)
                            successFunction(new Customer(customerResource));
                    },
                    function (data) {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    });
            };
            customerSrv.sendSmsActivationCode = function(customer,successFunction,errorFunction)
            {
                let customerSrv = customer.getObjectResource();

                customerSrv.$sendSmsActivationCode({}, //params
                    function (data) {
                        if (successFunction !=undefined)
                            successFunction(data.smsActivationCode);
                    },
                    function (data) {
                        let errorMessage = "Echec";
                        let errorCode = "";
                        if (data.status )
                        {
                            if (data.status=="409")
                                errorMessage = "Un compte possédant le même numéro de téléphone existe déjà";
                            errorCode =  data.status;
                        }
                        if (errorFunction !=undefined)
                            errorFunction(errorCode,errorMessage);
                    });
            };
            customerSrv.login = function(customer,successFunction,errorFunction)
            {
                let customerSrv = customer.getLoginRequest();
                customerSrv.$login({}, //params
                    function (data) {   //success
                        customer.setId(data.userId);
                        if (successFunction !=undefined)
                            successFunction(data);
                    },
                    function (data) {
                        const errorCode = data.status ? data.status : "";
                        let errorMessage = gettextCatalog.getString("Echec de la connexion.");
                        if (data.status && data.status=="401") {
                            errorMessage = gettextCatalog.getString("Email / mot de passe incorrect");
                        }
                        if (errorFunction !=undefined)
                            errorFunction(errorCode,errorMessage);
                    });

            };
            customerSrv.register = function(customer,successFunction,errorFunction) {
                let customerSrv = customer.getRegisterRequest();
                customerSrv.$register({}, //params
                    function (data) {
                        customer.setId(data.userId);
                        if (successFunction !=undefined) {
                            successFunction(data);
                        }
                    },
                    function (data) {
                        let errorMessage = gettextCatalog.getString("Création du compte impossible.");

                        let errorCode = "";
                        if (data.status && data.data ) {
                            if (data.status=="409" ) {
                                if (data.data.errorCode == "40901")

                                    errorMessage = gettextCatalog.getString("Création du compte impossible. Cet email est déjà utilisé.");
                                if (data.data.errorCode == "40902")
                                    errorMessage = gettextCatalog.getString("Création du compte impossible. Le numéro de téléphone est déjà utilisé.");
                                errorCode =  data.data.errorCode;
                            }
                        }
                        if (errorFunction !=undefined)
                            errorFunction(errorCode,errorMessage);
                    });

            };
            customerSrv.saveAccount = function(customer,successFunction,errorFunction)
            {
                let customerSrv = customer.getRegisterRequest();
                customerSrv.$saveAccount({}, //params
                    function (data) {
                        customer.password = null;
                        customer.currentPassword= null;
                        if (successFunction != undefined)
                            successFunction(customer);
                    },
                    function (data) {
                        customer.password = null;
                        customer.currentPassword= null;
                        let errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Vérifiez le mot de passe.");
                        let errorCode = "";
                        if (data.status && data.data )
                        {
                            if (data.status == "409" )
                            {
                                if (data.data.errorCode == "40901")
                                    errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Cet email est déjà utilisé.");
                                if (data.data.errorCode == "40902")
                                    errorMessage = gettextCatalog.getString("Mise à jour du compte impossible. Le numéro de téléphone est déjà utilisé.");
                                errorCode =  data.data.errorCode;
                            }
                        }
                        if (errorFunction != undefined)
                            errorFunction(errorCode,errorMessage);
                    });

            };
            customerSrv.changePwd = function(customer,successFunction,errorFunction)
            {
                let customerSrv = customer.getRegisterRequest();
                customerSrv.$changePwd({}, //params
                    function (data) {
                        customer.password = null;
                        customer.currentPassword= null;
                        if (successFunction != undefined)
                            successFunction(customer);
                    },
                    function (data) {
                        customer.password = null;
                        customer.currentPassword= null;
                        let errorMessage = gettextCatalog.getString("Mise à jour du compte impossible.");
                        let errorCode = "";
                        if (errorFunction != undefined)
                            errorFunction(errorCode,errorMessage);
                    });

            };
            customerSrv.forgotPwd = function(email,successFunction,errorFunction)
            {
                let customerSrv = new Customer_Resource();
                customerSrv.email = email;
                customerSrv.$forgotPwd({}, //params
                    function (data) {
                        if (successFunction != undefined)
                            successFunction(data);
                    },
                    function (response) {   //failure
                        let data = response.data;
                        if (errorFunction != undefined){
                            let accountNotExist = gettextCatalog.getString("Ce compte n'existe pas."),
                                errorMessage = gettextCatalog.getString("Echec de l'oubli de mot de passe.");

                            if (data.errorCode )
                            {
                                if (data.errorCode.startsWith("404")){
                                    errorMessage = accountNotExist;
                                }
                            }
                            errorFunction(errorMessage);
                        }
                    });

            };
            customerSrv.logout = function(customer,successFunction,errorFunction)
            {
                let customerSrv = new Customer_Resource();
                customerSrv.$logout({}, //params
                    function (data) {
                        if (successFunction != undefined)
                            successFunction(data);
                    },
                    function (data) {
                        let errorMessage = "Echec de la déconnexion.";
                        if (errorFunction != undefined)
                            errorFunction(errorMessage);
                    });

        };
        customerSrv.updateLocally =  function(id,resource)
        {
            let customer =  CustomerData.getById(id);
            if (customer!=null)
                customer.loadObject(resource);
            return customer;
        };
        customerSrv.removeLocally =  function(id)
        {
            let customer =  CustomerData.getById(id);
            if (customer!=null)
                CustomerData.remove(customer);
            return customer;
        };
        customerSrv.addLocally =  function(id,resource)
        {
            let customer =  CustomerData.getById(id);
            if (customer!=null) //check if resource already exist inside index (current action could be a 'cancel')
            {
                customer.loadObject(resource);
                CustomerData.add(customer);
            }
            else
            {
                customer = new Customer(resource);
                customer.id = id;
            }
            return customer;
        };

        customerSrv.restoreLocally =  function(id, resource) {
            let restoreCustomer = null;
            CustomerData.deletedCustomers = CustomerData.deletedCustomers.filter((customer) => {
                if (customer.id === id) {
                    restoreCustomer = customer;
                    return false;
                }
                return true;
            });

            if (restoreCustomer) {
                restoreCustomer.isDeleted = false;
                CustomerData.add(restoreCustomer);
            }

            return restoreCustomer;
        };

        return customerSrv;
    }

    ]);

angular.module('FlexyBeautyApp.services').
    factory('CustomerData',["$filter","ModelDataUtil", function ($filter,ModelDataUtil)
    {
        let  custDataSrv =
        {
            objCustomers : {},
            indexCustomers : [],
            activeCustomers : [],
            deletedCustomers : []
        };
        custDataSrv.getById =  function(customerId, isApplicationLoading)
        {
            let customer = null;
            if(isApplicationLoading) {
                customer = this.objCustomers[customerId];
            } else {
                customer = this.indexCustomers.find(customer => customer.id == customerId) || null;
            }
            return customer;
        };

        custDataSrv.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexCustomers.length)
                return this.indexCustomers[index];
            return null;
        };

        custDataSrv.getIndexOf = function(customer)
        {
            if (customer)
                return this.indexCustomers.indexOf(customer);
            return -1;
        };

        custDataSrv.add = function(customer, isApplicationLoading)
        {
            let realIndex = undefined,
                customerArray = this.activeCustomers;
            if (customer.isDeleted)
                customerArray =  this.deletedCustomers;

            if(isApplicationLoading ) {
                let key;
                if(customer != null && customer.id){
                    key = customer.id;
                }
                if (this.objCustomers[key] != null)
                {
                    realIndex = customerArray.indexOf(customer);
                }
                else
                {
                    this.objCustomers[key] = customer;
                    customerArray.push(customer);
                }
            }
            else{
                let index =  this.indexCustomers.indexOf(customer);
                if (index !== -1)
                {
                    realIndex = customerArray.indexOf(customer);
                }
                else
                {
                    if (customer.id && this.getById(customer.id)!=null)//very rare to true (just security)
                        index = this.indexCustomers.indexOf(this.getById(customer.id));
                    else
                    {
                        this.indexCustomers.push(customer);
                        customerArray.push(customer);
                    }
                }
            }
            if (realIndex === -1)
                customerArray.push(customer);
        };

        custDataSrv.remove =  function(customer)
        {
            let index =  this.activeCustomers.indexOf(customer);
            if (index !== -1)
            {
                this.activeCustomers.splice(index, 1);
                this.deletedCustomers.push(customer);
                customer.isDeleted=true;
            }
        };

        custDataSrv.restore =  function(customer)
        {
            let index =  this.deletedCustomers.indexOf(customer);
            if (index !== -1)
            {
                this.deletedCustomers.splice(index, 1);
                this.activeCustomers.push(customer);
                customer.isDeleted = false;
            }
        };

        custDataSrv.clear =  function()
        {
            this.indexCustomers = [];
            this.activeCustomers = [];
            this.deletedCustomers = [];
        };

        custDataSrv.sort =  function()
        {
            this.activeCustomers = $filter('orderBy')(this.activeCustomers,'lastName', false);
            this.deletedCustomers = $filter('orderBy')(this.deletedCustomers,'lastName', false);
        };

        custDataSrv.getActiveList =  function()
        {
            return this.activeCustomers;
        };

        custDataSrv.getDeletedList =  function()
        {
            return this.deletedCustomers;
        };

        custDataSrv.convertMapToArray = function(keepObject, isNewLoading){
            if (isNewLoading) {
                this.indexCustomers = ModelDataUtil.convertObjectToArray(this.objCustomers, this.indexCustomers);
                if (!keepObject) {
                    this.objCustomers = {};
                }
            } else {
                this.indexCustomers = ModelDataUtil.convertMapToArray(this.objCustomers, this.indexCustomers);
                this.objCustomers = null;
            }
        };

        custDataSrv.clearBookingsAndSales = function() {
            for (let customerId in this.objCustomers) {
                this.objCustomers[customerId].bookings = [];
                this.objCustomers[customerId].sales = [];
                this.objCustomers[customerId].giftItems = [];
            }
            this.activeCustomers.forEach(customer => {
                customer.bookings = [];
                customer.sales = [];
                customer.giftItems = [];
            });
        };

        return custDataSrv;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/Customer.js